module.exports = __webpack_public_path__ + "static/media/login1.a74f82f6.jpg";